var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaturesAtom3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 153,
    viewBox: "0 0 143 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.797 83.896L61.9037 77.7636L69.3408 131.78",
    stroke: "#263238",
    strokeWidth: 2.3576,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.946 89.0419C98.1475 82.8146 100.117 74.6872 106.344 70.8888C112.571 67.0904 120.699 69.0594 124.497 75.2867C128.295 81.514 126.326 89.6415 120.099 93.4399C113.872 97.2383 105.744 95.2692 101.946 89.0419Z",
    fill: "#80FFAF",
    stroke: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.64 83.8908C102.445 79.892 104.394 75.9151 108.049 73.6853",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4294 138.198C50.9346 130.829 53.2646 121.212 60.6336 116.717C68.0026 112.222 77.6201 114.552 82.1148 121.921C86.6096 129.29 84.2796 138.908 76.9106 143.402C69.5416 147.897 59.9242 145.567 55.4294 138.198Z",
    fill: "#80FFAF",
    stroke: "#263238"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1982 131.881C55.9739 127.178 58.2508 122.504 62.5604 119.876",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4522 52.3541C10.5823 47.6491 12.07 41.5084 16.7751 38.6385C21.4802 35.7686 27.6209 37.2563 30.4908 41.9613C33.3607 46.6664 31.8729 52.8071 27.1679 55.677C22.4628 58.5469 16.3221 57.0592 13.4522 52.3541Z",
    fill: "#80FFAF",
    stroke: "#263238"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0509 48.752C13.9043 45.7007 15.3789 42.6539 18.1819 40.9443L14.0509 48.752Z",
    fill: "#80FFAF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0509 48.752C13.9043 45.7007 15.3789 42.6539 18.1819 40.9443",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5332 89.6542C41.9959 80.576 44.8663 68.7277 53.9446 63.1903C63.0229 57.6529 74.8712 60.5234 80.4086 69.6017C85.9459 78.6799 83.0755 90.5282 73.9972 96.0656C64.9189 101.603 53.0706 98.7325 47.5332 89.6542Z",
    fill: "#FFDB80",
    stroke: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4187 81.5828C48.1421 75.8225 50.9439 70.0915 56.2112 66.8787",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesAtom3);
export default __webpack_public_path__ + "static/media/features-atom-3.c14fee38d1a0f2b1eebf17f2916d173c.svg";
export { ForwardRef as ReactComponent };